
import React, { useEffect } from 'react';
import { IconButton, ChatIcon } from '@livechat/ui-kit';

const Minimized = ({ maximize, initChat,refresh }) => {
    useEffect(() => {
		const params=new URLSearchParams(window.location.search).get("type");
	const mobileapp = params?false:true;
    const sid=localStorage.getItem('sid');
	console.log('[ece-chat][minimized] is it  mobile app? ',mobileapp);
	if(mobileapp || (sid && refresh)) {
		maximize();
	}
        /**
         * if (search) {
         *      maximize();
         * }
         */
    }, []);

    return (
        <div
            onClick={() => {
                maximize();
                initChat();
                window.parent.postMessage('maximize', '*');

            }}
            className="primary-color"
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '60px',
                height: '60px',
                color: '#fff',
                borderRadius: '50%',
                cursor: 'pointer',
            }}
        >
            <IconButton color="#fff">
                <ChatIcon />
                {/* <Icon component={svg} /> */}
            </IconButton>
        </div>
    );
} 

export default Minimized;